import { forwardRef } from "react";

import { Text } from "~/components/text";

export const StepsIndicator = forwardRef<
  HTMLDivElement,
  { current: number; last: number }
>(({ current, last }, ref) => {
  return (
    <div ref={ref} className="flex flex-col items-center gap-1">
      <span className="text-sm text-mama-default-primary">
        <Text tx="graph.text.stepsIndicator" txData={{ current, last }} />
      </span>
      <progress
        className="progress-primary progress w-full max-w-xs sm:w-56"
        value={current}
        max={last}
      />
    </div>
  );
});
StepsIndicator.displayName = "StepsIndicator";
